import type { AppRouteRecordRaw } from "shared/types";
import {
  LAYOUTS,
  MANAGER_ROLES,
  MEETING_OVERVIEW_ROLES,
  MODULE_SETTINGS,
} from "shared/constants";
import { GROUP_MEETING_ROUTE_NAMES } from "meetings/group-meeting/routes/routeNames";

export const groupMeetingManageFragment: AppRouteRecordRaw[] = [
  {
    path: "add-group-meeting",
    component: () => import("views/EmptyView.vue"),
    meta: {
      title: "Groepsbespreking toevoegen",
      roleRequired: MANAGER_ROLES,
      settingRequired: [MODULE_SETTINGS.GROUP_MEETING],
      layout: LAYOUTS.MAIN_NO_WRAPPER,
      hideTitle: true,
    },
    children: [
      {
        path: "",
        name: GROUP_MEETING_ROUTE_NAMES.CREATE,
        component: () =>
          import("meetings/group-meeting/pages/teacher/GroupMeetingCreatePage.vue"),
        meta: {
          title: "Groepsbespreking toevoegen",
          roleRequired: MANAGER_ROLES,
          // isAuthorized() reads settingRequired off the deepest matched record
          // only, so a leaf that omits it loses its parent's module gate.
          settingRequired: [MODULE_SETTINGS.GROUP_MEETING],
          hideSubmenu: true,
        },
      },
    ],
  },
  {
    path: "group-meeting",
    component: () => import("views/EmptyView.vue"),
    meta: {
      title: "Groepsbespreking beheren",
      roleRequired: MANAGER_ROLES,
      settingRequired: [MODULE_SETTINGS.GROUP_MEETING],
      layout: LAYOUTS.MAIN_NO_WRAPPER,
      hideTitle: true,
    },
    children: [
      {
        path: "edit/:id",
        name: GROUP_MEETING_ROUTE_NAMES.EDIT,
        component: () =>
          import("meetings/group-meeting/pages/teacher/GroupMeetingEditPage.vue"),
        meta: {
          title: "Groepsbespreking bewerken",
          roleRequired: MANAGER_ROLES,
          settingRequired: [MODULE_SETTINGS.GROUP_MEETING],
          hideSubmenu: true,
        },
      },
      {
        path: ":id",
        name: GROUP_MEETING_ROUTE_NAMES.MANAGE,
        component: () =>
          import("meetings/group-meeting/pages/teacher/GroupMeetingManagePage.vue"),
        meta: {
          // Read-only for a teamleader; the page hides its manage actions for
          // them. Widens the parent's MANAGER_ROLES for this leaf only.
          roleRequired: MEETING_OVERVIEW_ROLES,
          // isAuthorized() reads settingRequired off the deepest matched record
          // only, so a leaf that omits it loses its parent's module gate.
          settingRequired: [MODULE_SETTINGS.GROUP_MEETING],
          hideSubmenu: true,
        },
      },
    ],
  },
];
